export const customStyleDx = (colors: any) => `
.dx-widget {
   font-family: Manrope,sans-serif;
}

.dx-datagrid-rowsview .dx-master-detail-row:not(.dx-datagrid-edit-form) .dx-master-detail-cell {
  background-color: ${colors.secondary[50]};
}

.dx-checkbox-icon {
    border: 1px solid ${colors.secondary[500]};
    width: 20px;
    height: 20px;
    border-radius: 6px;
}

.dx-scrollable-container {
    overscroll-behavior: none;
}

.dx-checkbox-checked .dx-checkbox-icon::before {
    color: ${colors.secondary[50]};
}

.dx-checkbox-checked .dx-checkbox-icon {
    background-color: ${colors.primary.main};
    border: 1px solid ${colors.primary.main};
}

.error-checked .dx-checkbox-checked .dx-checkbox-icon {
    background-color: ${colors.primary.error};
    border: 1px solid ${colors.primary.error};
}

.dx-placeholder::before {
    content: "";
}

.dx-checkbox-indeterminate .dx-checkbox-icon::before {
    color: ${colors.secondary[50]};
}

.dx-checkbox-indeterminate .dx-checkbox-icon {
    background-color: ${colors.primary.main};
    border: 1px solid ${colors.primary.main};
}

.dx-pager .dx-pages .dx-navigate-button {
    padding: 9px 0 9px 13px;
}


.dx-datagrid-content .dx-datagrid-table .dx-row, .dx-datagrid-content .dx-datagrid-table .dx-row>tr {
    cursor: auto !important;
}
  
  .dx-datagrid-content .dx-datagrid-table [class*='column']+[class*='column']:last-child{
    cursor: auto;
}


.dx-datagrid-group-closed {
    height: 15px;
}

.dx-toolbar-after .dx-button-mode-contained {
    font-weight: bold;
    border-radius: 10px;
    height: 44px;
}

.dx-toolbar-after .dx-button-mode-default {
    font-weight: bold;
    border-radius: 10px;
    height: 44px;
}


.dx-toolbar-after > div:first-of-type .dx-button-mode-contained {
    background-color: ${colors.primary.light};
    border-color: ${colors.primary.light};
}
  
.dx-toolbar-after > div:nth-of-type(2) .dx-button-mode-contained {
    border-color: ${colors.secondary[500]};
}

.dx-toolbar-after > div:first-of-type .dx-button-mode-text.dx-button-default {
    background-color: ${colors.primary.light};
    border: 1px solid ${colors.primary.light};
    color: ${colors.secondary[700]};
}
  
.dx-toolbar-after > div:nth-of-type(2) .dx-button-mode-text.dx-button-default {
    border: 1px solid ${colors.secondary[500]};
    background-color: ${colors.secondary[50]};
    color: ${colors.secondary[700]};
}

.dx-pager .dx-pages .dx-page {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    font-weight: bold;
}
  
.dx-pager .dx-page-sizes .dx-selection, .dx-pager .dx-pages .dx-selection {
    background-color: ${colors.primary.lightest};
    color: ${colors.secondary[900]}
}
  
.dx-pager .dx-pages { 
    padding: 0px;
    width: 100%;
}
  
.dx-datagrid .dx-row>td {
     padding: 0px; 
}
  
.dx-datagrid-table .dx-row .dx-command-expand.dx-datagrid-group-space {
    padding: 12px 12px 12px 24px;
}
  
.dx-datagrid-rowsview .dx-row.dx-group-row td {
    padding: 12px 8px 12px 0px;
    height: 59px;
}
  
.dx-datagrid-content .dx-datagrid-table .dx-row>td, .dx-datagrid-content .dx-datagrid-table .dx-row>tr>td {
    vertical-align: middle;
}
  
.dx-data-row td {
    padding: 16px 24px !important;
    height: 72px;
}
  
.dx-datagrid-content .dx-datagrid-table .dx-row>td.dx-datagrid-group-space, .dx-datagrid-content .dx-datagrid-table .dx-row>tr>td.dx-datagrid-group-space {
    vertical-align: middle;
}
  
.dx-datagrid-content .dx-datagrid-table .dx-row .dx-command-expand {
    width: 66px;
    max-width: 66px;
}
  
.dx-datagrid-content .dx-datagrid-table .dx-row .dx-command-edit {
    width: 181px;
}
 
.dx-datagrid .dx-link {
    color: ${colors.primary.dark};
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
}
 
.dx-datagrid .dx-link:not(:first-of-type) {
    margin-left: 8px;
}
  
.dx-datagrid-content .dx-datagrid-table .dx-row>td.dx-datagrid-group-space, .dx-datagrid-content .dx-datagrid-table .dx-row>tr>td.dx-datagrid-group-space {
    border-right: 0 !important;
}
  
.dx-datagrid-content .dx-datagrid-table .dx-row>td.dx-datagrid-group-space+td, .dx-datagrid-content .dx-datagrid-table .dx-row>tr>td.dx-datagrid-group-space+td {
    border-left: 0 !important;
}
  
.dx-datagrid-content .dx-datagrid-table .dx-row>td.dx-datagrid-group-space+td, .dx-datagrid-content .dx-datagrid-table .dx-row>tr>td.dx-datagrid-group-space+td {
    padding-left: 0;
}
  
.dx-custom-cell-disable[role="gridcell"] {
    background-color: ${colors.secondary[200]};
}

.dx-custom-header-cell-full-width > .dx-datagrid-text-content {
    width: 100%;
}

.dx-datagrid-rowsview .dx-row.dx-group-row:not(.dx-row-focused) {
    background-color: ${colors.secondary[100]};
    color: ${colors.secondary[900]};
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
}
  
.dx-datagrid {
    color: ${colors.secondary[700]};
    border: none;
    background-color: ${colors.secondary[50]} !important;
}
  
  
.dx-datagrid-content .dx-datagrid-table .dx-row>td.dx-datagrid-group-space+td, .dx-datagrid-content .dx-datagrid-table .dx-row>tr>td.dx-datagrid-group-space+td {
    padding-left: 0 !important;
}

.dx-icon-clear::before {
    content: "\\2715" !important; 
}

.dx-datagrid-header-panel .dx-toolbar {
    margin-bottom: 20px;
    background-color: ${colors.secondary[100]};
}

.dx-datagrid-header-panel {
    border-bottom: 0;
    background-color: ${colors.secondary[100]};
}

.dx-datagrid-headers {
    border-color: ${colors.secondary[400]};
    border-style: solid;
    border-left-width: 1px;
    border-right-width: 1px;
    border-bottom-width: 1px;
    border-top-width: 1px;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    background-color: ${colors.secondary[200]};
}

.dx-datagrid-borders .dx-datagrid-rowsview, .dx-datagrid-headers+.dx-datagrid-rowsview, .dx-datagrid-rowsview.dx-datagrid-after-headers {
    border-top-width: 0px;
    border-color: ${colors.secondary[400]};
    border-style: solid;
    border-left-width: 1px;
    border-right-width: 1px;
    border-bottom-width: 0px;
}

.dx-datagrid-rowsview.dx-empty{
    border-bottom-width: 1px;

}

.dx-datagrid-pager {
    border-width: 1px;
    border-color: ${colors.secondary[400]};
    background-color: ${colors.secondary[50]};
    border-style: solid;
    border-radius: 0 0 8px 8px;
    height: 68px;
    display: flex;
    align-items: center;
}

.dx-pager .dx-pages .dx-separator {
    display: flex;
    align-self: center;
}


.dx-datagrid-header-panel {
    background-color: transparent;
}

 .dx-datagrid-header-panel .dx-toolbar {
   background-color: transparent;
}

.dx-datagrid .dx-row>td {
   padding: 0px; 
}

.dx-datagrid-table .dx-row .dx-command-expand.dx-datagrid-group-space {
  padding: 12px 12px 12px 24px;
}

.dx-datagrid-headers .dx-datagrid-table .dx-row>td {
  padding: 12px 24px;
  border-bottom: none;
  
}

.dx-datagrid-rowsview .dx-row.dx-group-row td {
  padding: 12px 8px 12px 0px;
  height: 59px;
}

.dx-datagrid-content .dx-datagrid-table .dx-row>td, .dx-datagrid-content .dx-datagrid-table .dx-row>tr>td {
  vertical-align: middle;
}

.dx-data-row td {
  padding: 16px 24px !important;
  height: 72px;
}

.dx-datagrid-content .dx-datagrid-table .dx-row>td.dx-datagrid-group-space, .dx-datagrid-content .dx-datagrid-table .dx-row>tr>td.dx-datagrid-group-space {
  vertical-align: middle;
}

.dx-datagrid-content .dx-datagrid-table .dx-row .dx-command-expand {
  width: 66px;
  max-width: 66px;
}

.dx-datagrid-content .dx-datagrid-table .dx-row .dx-command-edit {
  width: 181px;
}

.dx-datagrid .dx-link {
  color: ${colors.primary.dark};
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
}

.dx-datagrid .dx-link:not(:first-of-type) {
  margin-left: 8px;
}

.dx-datagrid-content .dx-datagrid-table .dx-row>td.dx-datagrid-group-space, .dx-datagrid-content .dx-datagrid-table .dx-row>tr>td.dx-datagrid-group-space {
  border-right: 0 !important;
}

.dx-datagrid-content .dx-datagrid-table .dx-row>td.dx-datagrid-group-space+td, .dx-datagrid-content .dx-datagrid-table .dx-row>tr>td.dx-datagrid-group-space+td {
  border-left: 0 !important;
}

.dx-datagrid-content .dx-datagrid-table .dx-row>td.dx-datagrid-group-space+td, .dx-datagrid-content .dx-datagrid-table .dx-row>tr>td.dx-datagrid-group-space+td {
  padding-left: 0;
}

.dx-datagrid-rowsview .dx-row.dx-group-row:not(.dx-row-focused) {
  background-color: ${colors.secondary[100]};
  color: ${colors.secondary[900]};
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
}

.dx-datagrid-rowsview .dx-row {
    border-top: 1px solid ${colors.secondary[400]};
    border-bottom: none;
}

.dx-datagrid-content .dx-datagrid-table .dx-row>td.dx-datagrid-group-space+td, .dx-datagrid-content .dx-datagrid-table .dx-row>tr>td.dx-datagrid-group-space+td {
  padding-left: 0 !important;
}

.dx-datagrid-search-text {
  color: ${colors.secondary[700]};
  background-color: ${colors.primary.light};
}

.dx-pager .dx-pages .dx-page-indexes {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: stretch;
}

.dx-pager .dx-pages .dx-prev-button {
    margin-right: auto;
    display: flex;
    gap: 6px;
}

.dx-pager .dx-pages .dx-next-button {
    margin-left: auto;
    display: flex;
    gap: 6px;
    margin-right: 34px;
}

.dx-pager .dx-pages .dx-prev-button::before {
    content: url("data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M16%207H3.83L9.42%201.41L8%200L0%208L8%2016L9.41%2014.59L3.83%209H16V7Z%22%20fill%3D%22%23323232%22%2F%3E%0A%3C%2Fsvg%3E%0A");
    width: 16px;
    height: 16px;
    position: static;
    margin-top: 0;
}

.dx-pager .dx-pages .dx-prev-button::after {
  content: 'Previous';
  font-weight: bold;
  font-family: 'Manrope';
  font-size: 1rem;
  letter-spacing: 0.16px;
  line-height: 23px;
}

.dx-pager .dx-pages .dx-next-button::before {
    content: 'Next';
    font-size: 1rem;
    font-weight: bold;
    position: static;
    width: auto;
    font-family: 'Manrope';
    line-height: 43px;
}
.dx-pager .dx-pages .dx-next-button::after {
  content: url("data:image/svg+xml, %3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M8%200L6.59%201.41L12.17%207H0V9H12.17L6.59%2014.59L8%2016L16%208L8%200Z%22%20fill%3D%22%23323232%22%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 16px;
  height: 16px;
}


.dx-row .dx-data-row .dx-column-lines {
    border-top: 1px solid red;
}

.dx-datagrid-header-panel .dx-texteditor-container {
    max-width: 320px;
    height: 44px;
}

.molson-dx-file-uploader {
    border: 2px dotted rgb(215, 215, 215);
    border-radius: 12px;
    padding: 16px 24px;
    display: flex;
    flex-direction: column;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    gap: 12px;
}

.dx-fileuploader-input-wrapper { 
    display: flex;
    align-items: baseline;
    justify-content: center;
}

.dx-fileuploader-wrapper .dx-button {
    box-shadow: none;
    display: block;
    height: 35px;
}

.dx-fileuploader-wrapper .dx-button-text {
    color: ${colors.secondary[900]};
    text-transform: none;
    font-weight: 700;
    font-size: 16px;
    letter-spacing: 0.16px;
    line-height: 20px;
    text-decoration: underline;
}

.dx-fileuploader-wrapper .dx-button-has-text .dx-button-content {
    padding: 0;
    height: 35px;
}

.dx-fileuploader-wrapper .dx-button.dx-state-hover {
    background-color: transparent;
}

.dx-fileuploader-input-container {
    height: 35px;
    width: 130px;
}

.dx-button-mode-contained {
    background-color: rgb(255, 255, 255);
    color: rgb(51, 51, 51);
}

.dx-fileuploader-input-wrapper::after, .dx-fileuploader-input-wrapper::before {
    width: auto;
}

.dx-fileuploader-input-label {
    width: fit-content;
    padding-left: 4px;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.16px;
    line-height: 20px;
    color: ${colors.secondary[600]};
}

.dx-datagrid-header-panel {
    padding-right: 0;
    background-color: transparent;
}

 .dx-datagrid-header-panel .dx-toolbar {
   background-color: transparent;
}

tbody > tr.dx-row.dx-freespace-row.dx-column-lines {
  height: auto !important;
}

.dx-datagrid-header-panel .dx-toolbar-item-content > .dx-texteditor {
  min-width: 300px
}

tr.dx-row.dx-virtual-row.dx-column-lines {
    display: none;
}

.dx-datagrid .dx-datagrid-content-fixed .dx-datagrid-table .dx-col-fixed {
    background-color: ${colors.secondary[50]};
}

.dx-datagrid-headers > .dx-datagrid-content > .dx-datagrid-table .dx-col-fixed {
    background-color: transparent;
}


.dx-datagrid-headers > .dx-datagrid-content > .dx-datagrid-table {
    background-color: ${colors.secondary[200]};
    border-radius: 8px;
    max-width: 100%;
}

.dx-datagrid-content-fixed  {
    max-width: min-content;
}

.dx-datagrid-headers .dx-datagrid-content {
    margin-bottom: 0px;
}

.dx-toolbar .dx-toolbar-items-container {
    height: 44px;
}

.dx-pager .dx-pages .dx-next-button, .dx-pager .dx-pages .dx-prev-button {
    color: ${colors.secondary[700]}
}

.dx-pager .dx-pages .dx-next-button::after, .dx-pager .dx-pages .dx-prev-button::before {
    margin-top: 20%;
}

.table-border-red .dx-datagrid-headers {
    border-top-color: ${colors.primary.error};
    border-left-color: ${colors.primary.error};
    border-right-color: ${colors.primary.error};
}

.table-border-red .dx-datagrid-headers+.dx-datagrid-rowsview {
    border-top-color: ${colors.primary.error};
    border-left-color: ${colors.primary.error};
    border-right-color: ${colors.primary.error};
    border-bottom-color: ${colors.primary.error};
}

.table-border-red .dx-scrollable-wrapper {
    border-bottom: 1px solid ${colors.primary.error};
}

.dx-popup-content .dx-list-item-content {
    text-wrap: auto !important;
    text-overflow: unset !important;
    white-space: normal !important;
}
`
